import IUser from 'interfaces/models/user';
import IUserRole from 'interfaces/models/userRole';
import { IPaginationParams, IPaginationResponse } from 'interfaces/pagination';
import IUserToken from 'interfaces/tokens/userToken';
import * as Rx from 'rxjs';
import * as RxOp from 'rxjs-operators';

import apiService, { ApiService } from './api';

export class UserService {
  constructor(private apiService: ApiService) {
    this.apiService = apiService;
  }

  public list(params: IPaginationParams): Rx.Observable<IPaginationResponse<IUser>> {
    return this.apiService.get('/user', params);
  }

  public roles(refresh: boolean = false): Rx.Observable<IUserRole[]> {
    return this.apiService.get('/user/roles').pipe(
      RxOp.cache('user-service-roles', { refresh }),
      RxOp.map(({ data }) => data),
    );
  }

  public save(model: IUser): Rx.Observable<IUser> {
    return this.apiService.post('/user', model);
  }

  public delete(id: number): Rx.Observable<void> {
    return this.apiService.delete(`/user/${id}`);
  }

  public loginByEventHash(data: any): Rx.Observable<any> {
    return this.apiService.post('/auth/loginbyeventhash', data).pipe(RxOp.map(res => res.data[0]));
  }

  public loginAs(data: any): Rx.Observable<IUserToken> {
    return this.apiService.post('/user/login_as', data).pipe(RxOp.map(res => res.data[0]));
  }

  public acpoLoginAs(data: any): Rx.Observable<IUserToken> {
    return this.apiService.post('/user/acpo_login_as', data).pipe(RxOp.map(res => res.data[0]));
  }

  public acceptPartnerTerms(data: any): Rx.Observable<any> {
    return this.apiService.post('/user/accept_partner_terms', data);
  }

  public setMeAsProducer(data: any): Rx.Observable<any> {
    return this.apiService.post('/user/set_as_producer', data);
  }

  // public eduzzFormBuilderGenerateAccessToken(): Rx.Observable<any> {
  //   return this.apiService.post('/user/eduzz_form_builder_generate_access', {});
  // }
}

const userService = new UserService(apiService);
export default userService;
